import React from 'react';
import { connect } from 'react-redux';
import { Link, Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import Pages from '../../pages/pages/Pages';
import Settings from '../../pages/settings/Settings';
import Edit from '../../pages/edit/Edit';
import View from '../../pages/view/View';
import SearchPage from '../../pages/search/SearchPage';
import NotFound from '../../pages/NotFound';
import { history } from '../../../config/redux.store';
import { Layout, Menu } from 'antd';

const { Header, Content, Footer } = Layout;

const Author = () => {
    return (
        <Layout className="layout">
            <ConnectedRouter history={history}>
                <Header theme="dark" className="header">
                    <div className="logo">
                        <Link to="/" className="logo__link">
                            <img src="https://upload.wikimedia.org/wikipedia/fr/7/74/Logo_Barry_Callebaut.svg" width="200" alt="Barry callebaut logo" />
                        </Link>
                    </div>
                    <Menu className="menu" theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
                        <Menu.Item key="1">
                            <Link to="/">Pages</Link>
                        </Menu.Item>
                        <Menu.Item key="2">
                            <Link to="/settings">Settings</Link>
                        </Menu.Item>
                    </Menu>
                </Header>

                <Content style={{ marginTop: '64px', paddingTop:'2rem', overflow: 'auto' }}>
                    <Layout>
                        <Content className="content">
                            <Switch>
                                <Route path="/" exact component={Pages} />
                                <Route path="/pages" component={Pages} />
                                <Route path="/settings" component={Settings} />
                                <Route path="/settings/removeSearchIndex/*" component={Settings} />
                                <Route path="/edit" component={Edit} />
                                <Route path="/view" component={View} />
                                <Route path="/search" component={SearchPage} />
                                <Route component={NotFound} />
                            </Switch>
                        </Content>

                        <Footer>&copy; Barry Callebaut</Footer>
                    </Layout>
                </Content>
            </ConnectedRouter>
        </Layout>
    );
};

const mapStateToProps = state => ({});
const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Author);
